import React, { useState } from "react";
import SimpleReactValidator from "simple-react-validator";
import moment from "moment";
import "moment/locale/es";
const ln = navigator.language || navigator.userLanguage;

const CustomSimpleReactValidator = (options) => {
  const [, forceUpdate] = useState();

  return new SimpleReactValidator({
    autoForceUpdate: { forceUpdate: forceUpdate },
    element: (message) => (
      <div className="text-red-600 pt-2 text-xs">{message}</div>
    ),
    validators: {
      /* required: {
        message: "El campo :values es obligatorio.",
        rule: (val, params, validator) => {
          console.log("val", val, val.length === 0);
          return (
            val !== "" || val !== undefined || val !== null || val.length === 0
          );
        },
        messageReplace: (message, params) => message.replace(":values", params), // optional
        required: true,
      }, */
      min: {
        message: "Debe tener :values o más caracteres.",
        rule: (val, params, validator) => {
          return val.length >= params;
        },
        messageReplace: (message, params) => message.replace(":values", params), // optional
        required: true,
      },
      afterOrEqual: {
        message: "Debe ser posterior a :values.",
        rule: (val, params, validator) => {
          moment.locale("es");
          console.log("lang", ln);
          if (val !== "") {
            console.log("isBefore", !val.isBefore(params[0]));
            return !val.isBefore(params[0]);
          }
        },
        messageReplace: (message, params) =>
          message.replace(
            ":values",
            params.map((p) => p.locale("es").format("YYYY-MM-DD"))
          ), // optional
        required: true,
      },
    },
    ...options,
  });
};
export default CustomSimpleReactValidator;
